module.exports = __webpack_public_path__ + "media/entities/1031-194d59d8.png";